import Base from './base'

export default class Option extends Base {
  getDebtorCategories(params: object = {}) {
    return this.apiClient.get('options/debtor-categories', params)
  }

  getDropdownOptions(params: object = {}) {
    return this.apiClient.get('options/dropdown-options', params)
  }

  addDropdownOption(params: object = {}) {
    return this.apiClient.post('options/dropdown-options', params)
  }
}
